import {
    useDeleteLoyaltyConfigMutation,
    useLazyGetLoyaltyProgramsQuery,
} from '@/services/innovorder/modules/modules.endpoints';

import { useGetLoyaltyConfigQuery } from '@/services/innovorder/modules/modules.endpoints';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

const useZerosixLoyaltyIntegrationVM = () => {
    const { restaurantId } = useParams<{ restaurantId: string; brandId: string }>();
    const [deleteConfig, { isLoading: isDeleting, isSuccess: isDeleteSuccess }] = useDeleteLoyaltyConfigMutation();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const {
        data: loyaltyConfig,
        error,
        isLoading,
    } = useGetLoyaltyConfigQuery({
        restaurantId: Number(restaurantId),
    });
    const hasZerosixConfig = useMemo(() => {
        if (error) {
            return false;
        }
        return loyaltyConfig?.provider === 'zerosix';
    }, [loyaltyConfig, error]);

    useEffect(() => {
        if (isDeleteSuccess) {
            setIsModalOpen(false);
        }
    }, [isDeleteSuccess]);

    return {
        hasZerosixConfig: hasZerosixConfig,
        loyaltyConfig,
        isLoading,
        isDeleting,
        isModalOpen,
        setIsModalOpen,
        deleteConfig,
    };
};

export default useZerosixLoyaltyIntegrationVM;
